import React from 'react'
import {
  Box,
  Button,
  Chip,
  CircularProgress,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Switch,
  Typography,
} from '@mui/material'
import { FileDownload as DownloadIcon } from '@mui/icons-material'

interface PeriodOption {
  value: number
  label: string
}

interface CatalogueHeaderProps {
  title: string
  periodOptions: PeriodOption[]
  months: number
  onMonthsChange: (next: number) => void
  splOnly: boolean
  onSplOnlyChange: (next: boolean) => void
  exporting: boolean
  onExport: () => void
  exportDisabled: boolean
  periodCaption?: React.ReactNode
}

const CatalogueHeader: React.FC<CatalogueHeaderProps> = ({
  title,
  periodOptions,
  months,
  onMonthsChange,
  splOnly,
  onSplOnlyChange,
  exporting,
  onExport,
  exportDisabled,
  periodCaption,
}) => (
  <Box sx={{ mb: 3 }}>
    <Stack direction="row" alignItems="center" spacing={2} flexWrap="wrap">
      <Typography variant="h4" component="h1">
        {title}
      </Typography>
      <Chip
        label="BETA"
        size="small"
        sx={{
          fontSize: '0.7rem',
          fontWeight: 700,
          letterSpacing: '0.05em',
          height: 24,
          bgcolor: 'warning.main',
          color: '#fff',
        }}
      />
      <Box sx={{ flexGrow: 1 }} />
      <FormControl size="small" sx={{ minWidth: 160 }}>
        <InputLabel id="months-label">Period</InputLabel>
        <Select
          labelId="months-label"
          label="Period"
          value={months}
          onChange={(e) => onMonthsChange(Number(e.target.value))}
        >
          {periodOptions.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControlLabel
        control={
          <Switch checked={splOnly} onChange={(_, v) => onSplOnlyChange(v)} />
        }
        label="PWX Std Prod List only"
      />
      <Button
        variant="outlined"
        size="small"
        startIcon={exporting ? <CircularProgress size={14} /> : <DownloadIcon />}
        onClick={onExport}
        disabled={exportDisabled}
      >
        {exporting ? 'Exporting…' : 'Export Excel'}
      </Button>
    </Stack>
    {periodCaption && (
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: 'block', mt: 0.5 }}
      >
        {periodCaption}
      </Typography>
    )}
  </Box>
)

export default CatalogueHeader
